import instance from '../axios'
import { DiscoverItem, DiscoverResponse, Mood } from '../types/Discover'

const discoverApi = {
    async get(page: number = 1) {
        const response = await instance.get<DiscoverResponse>(`/discover?page=${page}`)
        return response.data
    },

    async getMoods() {
        const response = await instance.get<Mood[]>('/discover/moods')
        return response.data
    },

    // Signed-in callers automatically get already-watched titles filtered out
    // (the axios interceptor attaches the token). Results shuffle between
    // calls by design, so refetching the same mood gives a fresh mix.
    async getMoodResults(key: string, count: number = 20, mediaType: 'all' | 'movie' | 'tv' = 'all') {
        const response = await instance.get<DiscoverItem[]>(
            `/discover/mood/${key}?count=${count}&mediaType=${mediaType}`
        )
        return response.data
    },
}

export default discoverApi
